import React, { Component } from 'react';
import PropTypes from 'prop-types';

import RoundedTable from '../RoundedTable';

import capitalize from 'lodash/capitalize';

class SortableTable extends Component {
  constructor(props){
    super(props);

    this.state = {
      sortKey: props.defaultSortKey || null,
      sortDescending: props.defaultSortDescending || true
    };
  }

  handleHeaderClick(column){
    const { sortKey, sortDescending } = this.state;

    const { onSort } = this.props;

    if(!column.sortable) return;

    if(sortKey === column.name){
      this.setState({sortDescending:!sortDescending});
      onSort(column.name,!sortDescending);
    } else {
      this.setState({sortKey:column.name,sortDescending:true});
      onSort(column.name,true);
    }
  }

  render(){
    const { columns, children, hideHeadersOnEmpty, emptyText } = this.props;

    const { sortKey, sortDescending } = this.state;

    if(children.length === 0 && emptyText.length > 0 && hideHeadersOnEmpty){
      return (
        <div className='EmptyListPlaceholder'>{emptyText}</div>
      )
    }

    return (
      <RoundedTable>
        <thead>
          <tr>
            {columns.map((column,i) => (
              <th
                key={i}
                style={{
                  cursor:column.sortable ? 'pointer' : 'default',
                  fontWeight:sortKey === column.name || sortKey === null? 'bold' : 'normal',
                  userSelect:'none',
                  overflow:'hidden',
                  textOverflow:'ellipsis',
                  width:`${column.width || Math.round(100 / columns.length)}%`
                }}
                onClick={() => this.handleHeaderClick(column)}
              >
                <span
                  style={{
                    // TODO: MAKE THIS WORK
                    // display:'inline-block',
                    // backgroundColor:'blue',
                    // maxWidth:`calc(100% - ${column.sortable ? 15 : 0})`,
                    // overflow:'hidden',
                    // textOverflow:'ellipsis'
                  }}
                >
                  {column.displayName || capitalize(column.name)}
                </span>
                {column.sortable && (
                  <span>
                    &nbsp;
                    <i
                      className={`fa fa-caret-${sortKey === column.name && !sortDescending ? 'up' : 'down'}`}
                      aria-hidden="true"
                    ></i>
                  </span>
                )}
              </th>
            ))}
          </tr>
        </thead>
        {children.length === 0 && emptyText.length > 0 ? (
          <div className='EmptyListPlaceholder'>
            {emptyText}
          </div>
        ) : (
          <tbody>
            {children}
          </tbody>
        )}
      </RoundedTable>
    )
  }
}

SortableTable.propTypes = {
  columns:PropTypes.arrayOf(PropTypes.shape({
    name:PropTypes.string.isRequired,
    width:PropTypes.number,
    displayName:PropTypes.string,
    sortable:PropTypes.bool
  })),
  onSort:PropTypes.func,
  onPage:PropTypes.func,
  children:PropTypes.node,
  emptyText:PropTypes.string,
  hideHeadersOnEmpty:PropTypes.bool,
  defaultSortKey:PropTypes.string,
  defaultSortDescending:PropTypes.bool
};

SortableTable.defaultProps = {
  children:[],
  columns:[],
  onSort:() => {},
  onPage:() => {},
  emptyText:'',
  hideHeadersOnEmpty:false,
  defaultSortKey: null,
  defaultSortDescending:true
};

export default SortableTable;



// WEBPACK FOOTER //
// ./src/shared/components/SortableTable/index.js